import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyle } from './theme/globalStyle';
import Application from './App.styles';
import Finder from './components/Finder';
import FolderIconSrc from './assets/png/folder.png';
import 'react-image-lightbox/style.css';

const width = '60px';

const Folder = styled.div`
  width: ${width};
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

const FolderIcon = styled.img`
  width: ${width};
`;

const FolderText = styled.p`
  text-align: center;
  color: #ffffff;
  text-shadow: 0px 0px 6px #000000;
`;

const App = () => {
  const [animate, setAnimate] = useState(false);

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <Application>
          <Folder onClick={() => setAnimate(true)}>
            <FolderIcon src={FolderIconSrc} />
            <FolderText>
              <FormattedMessage
                id='app.name'
                defaultMessage="Fialkovskaia's Finder"
              />
            </FolderText>
          </Folder>
          <Transition in={animate} timeout={0} mountOnEnter>
            {(animationState) => (
              <Finder
                animationState={animationState}
                close={() => setAnimate(false)}
              />
            )}
          </Transition>
        </Application>
      </ThemeProvider>
    </>
  );
};

export default App;
